import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

import { CommonDataService } from '../../services/common-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-products-you-may-like',
  templateUrl: './products-you-may-like.component.html',
  styleUrls: ['./products-you-may-like.component.css']
})
export class ProductsYouMayLikeComponent implements OnInit {

  modelName = "Product";
  products = []
  displayedProducts = []
  loading = true

  constructor(
    private router: Router,
    private _data: CommonDataService
  ) {

    let queryData = new FormData();
    queryData.append('modelName', this.modelName);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.products = data['covers'];
          this.loading = false


        },
        error => {

          console.log(error);
          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Failed to get products.'
        });

        $('#loader').hide();

        },

        () => {
            $('#loader').hide();
        }
      );
   }

  ngOnInit() {
    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

}
